import styled, { keyframes, css } from 'styled-components';
import { SurfaceCard } from '@/styles/shared.styled';

const highlightFlash = keyframes`
  0% { box-shadow: 0 0 0 2px rgba(37, 99, 235, 0.4); }
  100% { box-shadow: none; }
`;

export const Card = styled(SurfaceCard)<{ $cited?: boolean; $highlighted?: boolean }>`
  padding: ${({ theme }) => theme.spacing[5]};
  margin-bottom: ${({ theme }) => theme.spacing[3]};
  transition: all ${({ theme }) => theme.transitions.base};
  cursor: pointer;
  ${({ $cited, theme }) => $cited && css`border-left: 3px solid ${theme.colors.primary};`}
  ${({ $highlighted }) => $highlighted && css`animation: ${highlightFlash} 1.5s ease-out;`}

  &:hover {
    box-shadow: ${({ theme }) => theme.shadows.md};
    border-color: ${({ theme }) => theme.colors.primaryLight};
  }
`;

export const CardHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: ${({ theme }) => theme.spacing[3]};
`;

export const Title = styled.span`
  font-size: ${({ theme }) => theme.fontSizes.base};
  font-weight: ${({ theme }) => theme.fontWeights.semibold};
  color: ${({ theme }) => theme.colors.primary};
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const Score = styled.span`
  font-size: ${({ theme }) => theme.fontSizes.xs};
  color: ${({ theme }) => theme.colors.textMuted};
  white-space: nowrap;
  margin-left: ${({ theme }) => theme.spacing[3]};
`;

export const Meta = styled.div`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing[4]};
  font-size: ${({ theme }) => theme.fontSizes.xs};
  color: ${({ theme }) => theme.colors.textMuted};
  margin-bottom: ${({ theme }) => theme.spacing[3]};
`;

export const Snippets = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing[2]};
`;

export const Snippet = styled.div`
  padding: ${({ theme }) => theme.spacing[3]};
  background-color: ${({ theme }) => theme.colors.bgMuted};
  border-radius: ${({ theme }) => theme.radii.lg};
  font-size: ${({ theme }) => theme.fontSizes.sm};
  line-height: ${({ theme }) => theme.lineHeights.relaxed};
  color: ${({ theme }) => theme.colors.textSecondary};

  mark {
    background-color: rgba(212, 168, 67, 0.3);
    color: inherit;
    padding: 0 0.125rem;
    border-radius: 0.125rem;
  }
`;

export const SnippetPage = styled.div`
  font-size: ${({ theme }) => theme.fontSizes.xs};
  color: ${({ theme }) => theme.colors.textMuted};
  margin-bottom: ${({ theme }) => theme.spacing[1]};
`;

export const AiBadge = styled.span`
  display: inline-flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing[1]};
  padding: 0.125rem ${({ theme }) => theme.spacing[2]};
  background: rgba(37, 99, 235, 0.08);
  color: ${({ theme }) => theme.colors.primary};
  border-radius: ${({ theme }) => theme.radii.full};
  font-size: ${({ theme }) => theme.fontSizes.xs};
  font-weight: ${({ theme }) => theme.fontWeights.medium};
  white-space: nowrap;
`;
